import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { Flex, Box } from 'grid-styled'
import { utils } from 'alelo-logic'

import { Container } from './styles'

import { labels } from './data.json'

import { renderTextInput } from '../../../utils/renderInputs'

const IdentifierQuantityForm = props => {
  const { onChange } = props
  return (
    <form onChange={onChange}>
      <Container>
        <Flex wrap width={[1, 7 / 12]}>
          <Box width={1} mb={3} mt={50}>
            <Field
              component={renderTextInput}
              label={labels.identifiersQuantity}
              name="identifiersQuantity"
              type="number"
              placeholder="Digite aqui"
              validate={utils.emptyFieldValidate}
              normalize={utils.numberMask}
              maxlength="10"
              isRequired
              id="qtdVeloeTags"
            />
          </Box>
        </Flex>
      </Container>
    </form>
  )
}

const mapStateToProps = state => ({})

const form = reduxForm({
  form: 'identifierQuantity',
  enableReinitialize: true,
  destroyOnUnmount: false
})(IdentifierQuantityForm)

export default connect(mapStateToProps, undefined)(form)



// WEBPACK FOOTER //
// ./src/app/modules/IdentifierQuantityForm/index.js